function showBendingCheckSummary() {
    var design = activeProject.design;
    var checks = g_results["bending_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var controlling_Mu = checks["controlling_Mu"];
    var controlling_Mn = checks["controlling_Mn"];
    var controlling_equation = checks["controlling_code_equation"];
    var controlling_case = checks["controlling_case"];
    var controlling_location = checks["controlling_loc"];
    var controlling_Lb = checks["controlling_Lb"];
    
    const nice_eq_index = Number(controlling_case.split('EQ')[1])

    var nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="glyphicon glyphicon-ok text-success"></i>' : '<i class="glyphicon glyphicon-remove text-danger"></i>';
    setDesignPanelSuccessOrFail(success, '#bending-design-panel');

    var str = '<div class="panel-heading">';
    str += '<h3 class="panel-title"><span class="">';
    str += designStatusStr + ' Bending</span><span class="pull-right">' + controlling_unity.toFixed(2) + '</span></h3></div>';

    str += "<table class='table'>";

    str += "<tr>";
    if(activeProject.isEngineeredLumber) {
        str += "<td>Mu <span class='ws-ui-info'>(Demand)</span></td>";
    } else if(activeProject.isASD) {
        str += "<td>Ma <span class='ws-ui-info'>(Demand)</span></td>";
    } else {
        str += "<td>Mu <span class='ws-ui-info'>(Demand)</span></td>";
    }
    str += "<td><span style='float:right;'>"+ showBigMoment(controlling_Mu) + " " + bigMomentUnit() + "</span></td></tr>";

    str += "<tr>";
    if(activeProject.isEngineeredLumber) {
        str += "<td>Mn <span class='ws-ui-info'>(Capacity)</span></td>";
    } else if(activeProject.isASD) {
        str += "<td>Mn/&Omega; <span class='ws-ui-info'>(Capacity)</span></td>";
    } else if(activeProject.isNoDesign) {
        str += "<td>Mn <span class='ws-ui-info'>(Capacity)</span></td>";
    } else {
        str += "<td>&Phi; Mn <span class='ws-ui-info'>(Capacity)</span></td>";
    }
    str += "<td><span style='float:right;'>"+ showBigMoment(controlling_Mn) + " " + bigMomentUnit() + "</span></td></tr>";

    str += "<tr>";
    str += "<td>Controlling Equation</td>";
    if(activeProject.isEngineeredLumber) {
        str += "<td><span style='float:right;'>Mu &le; Mn";
    } else if(activeProject.isFormTechShape) {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    } else if(activeProject.isNoDesign) {
        str += "<td><span style='float:right;'>Mn = Fy &bull; Zx";
    } else {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    }

    str += "<tr>";
    str += "<td>Location</td>";
    str += "<td><span style='float:right;'>"+ showLengthWithUnits(controlling_location) + "</span></td></tr>";

    str += "<tr>";
    str += "<td>Load Combination</td>";
    str += "<td><span style='float:right;'>" + nice_case  +"</span></td></tr>";

    if(activeProject.isEngineeredLumber) {
        str += "<tr>";
        str += "<td>Lb</td>";
        str += "<td><span style='float:right;'>Assumed Continuous</span></td></tr>";
    } else if(design.bracingType === 'unbraced' && design.designType !== 'None' ) {
        str += "<tr>";
        str += "<td>Lb - Unbraced</td>";
        str += "<td><span style='float:right;'>Much larger than " + showLengthWithUnits(activeProject.beam.TotalLength()) + "</span></td></tr>";
    } else if(design.bracingType !== 'continuous' && design.designType !== 'None' ) {
        str += "<tr>";
        str += "<td>Lb</td>";
        str += "<td><span style='float:right;'>" + showLengthWithUnits(controlling_Lb) + "</span></td></tr>";
    }

    str += "</table>";
    $('#bending-design-panel').html(str);
}
